import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  content: {
    minHeight: '100vh',
    '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
    background: '#f2f5f6',
    color: '#263d48',
  },
  header: { position: 'fixed', width: '100%', zIndex: theme.zIndex.appBar },
  body: {
    padding: '76px 16px 20px',
    maxWidth: 1600,
    margin: '0 auto',
    [theme.breakpoints.down('sm')]: { padding: '72px 8px 16px' },
  },
  introduction: { marginBottom: 12 },
  title: { fontWeight: 600, marginBottom: 4 },
  muted: { color: '#586d78' },
  notice: {
    background: '#e8f0f3',
    borderLeft: '3px solid #527b8e',
    padding: '8px 12px',
    marginBottom: 12,
  },
  panel: {
    padding: 12,
    marginBottom: 12,
    border: '1px solid #d7e1e5',
    boxShadow: 'none',
    borderRadius: 8,
    [theme.breakpoints.down('sm')]: { padding: 8 },
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 8,
    flexWrap: 'wrap',
    '& .MuiTypography-h6': { fontSize: 18, lineHeight: 1.4 },
    '& .MuiButton-root': { minHeight: 40 },
  },
  metadata: { margin: '6px 0 10px', overflowWrap: 'anywhere' },
  filters: {
    display: 'flex', flexWrap: 'wrap', alignItems: 'flex-start', gap: 8, marginTop: 10,
    marginBottom: 10,
    '& .MuiTextField-root': { minWidth: 180, flex: '0 1 220px' },
    '& .MuiInputBase-root': { minHeight: 40 },
    '& .MuiFormHelperText-root': { margin: '3px 0 0', lineHeight: 1.4 },
    '& .MuiFormControlLabel-root': { margin: 0, minHeight: 44 },
    '& .MuiFormControlLabel-label': { fontSize: 14, lineHeight: 1.4 },
    '& .MuiCheckbox-root': { padding: 10 },
    '& .MuiButton-root': { minHeight: 44 },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column', alignItems: 'stretch',
      '& .MuiTextField-root': { minWidth: 0, width: '100%', flex: '0 1 auto' },
      '& .MuiButton-root': { alignSelf: 'flex-start' },
    },
  },
  highPrep: { background: '#fff3dc', fontWeight: 600, color: '#694708' },
  highPrepLabel: { display: 'block', fontSize: 12, marginTop: 3 },
  table: {
    width: '100%',
    tableLayout: 'fixed',
    borderCollapse: 'collapse',
    textAlign: 'left',
    '& th, & td': { padding: '10px 8px', verticalAlign: 'top', borderBottom: '1px solid #d7e1e5', lineHeight: 1.45 },
    '& th': { background: '#e8f0f3', color: '#3d5967', fontSize: 12, fontWeight: 600, overflowWrap: 'anywhere' },
    '& td': { overflowWrap: 'anywhere', fontSize: 14 },
    '& th:nth-child(1)': { width: '21%' },
    '& th:nth-child(2)': { width: '13%' },
    '& th:nth-child(3)': { width: '23%' },
    '& th:nth-child(4)': { width: '16%' },
    '& th:nth-child(5)': { width: '27%' },
    [theme.breakpoints.down('sm')]: {
      '&, & tbody, & tr, & td': { display: 'block', width: '100%', boxSizing: 'border-box' },
      '& thead': { position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)' },
      '& tr': { padding: '6px 0', borderBottom: '2px solid #d7e1e5' },
      '& td': { borderBottom: 'none', padding: '5px 8px' },
      '& td::before': { content: 'attr(data-label)', display: 'block', fontSize: 12, fontWeight: 600, color: '#586d78', marginBottom: 2 },
    },
  },
  name: { fontWeight: 600 },
  status: {
    display: 'inline-block',
    padding: '3px 6px',
    borderRadius: 4,
    background: '#e8f0f3',
    color: '#36596b',
    fontSize: 12,
    fontWeight: 600,
  },
  closed: { background: '#f6ece1', color: '#805526' },
  multiline: { whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' },
  reason: { marginTop: 4 },
  note: { marginTop: 6, paddingTop: 6, borderTop: '1px solid #d7e1e5' },
  noteLabel: { display: 'block', color: '#586d78', fontWeight: 600, marginBottom: 2 },
  state: { padding: '24px 12px', textAlign: 'center', '& button': { marginTop: 10, minHeight: 44 } },
  stateTitle: { marginBottom: 6 },
}));
